import axios, { AxiosResponse } from 'axios'
import store from '../store'
import * as Sentry from '@sentry/browser'
import { getRequestFile, getRequestFileBlobGateway, postRequestFile } from '@/services/api.service'
import { VuexOidcState } from 'vuex-oidc'

export async function getFileBlobv2(endpoint: string, signal?: AbortSignal): Promise<any> {
  try {
    const res = await getRequestFile(endpoint, signal)
    return res
  } catch (e: any) {
    if (e.message !== 'canceled') {
      Sentry.captureException(e)
      throw new Error('Could not load file')
    }
  }
}

export async function postFilev2(
  endpoint: string,
  file: File,
  iD: string,
  typ: string
): Promise<any> {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('objectId', iD)
    formData.append('objectType', typ)
    return await postRequestFile(endpoint, formData, undefined, 0)
  } catch (e: any) {
    Sentry.captureException(e)
  }
}

export async function getFileBlob(endpoint: string): Promise<any> {
  const url = window.appConfig.VITE_API_FILE_SERVICE_URL + endpoint
  const state = (store.state as any).oidcStore as VuexOidcState
  const headers = {
    'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + state.access_token
  }
  try {
    const data = await axios.get(url, {
      headers: headers,
      responseType: 'blob'
    })
    return data
  } catch (e: any) {
    Sentry.captureException(e)
    console.error(e)
  }
}

export async function getAttachmentFileBlob(attachment: {
  realmId: string
  storageName: string
}): Promise<AxiosResponse<Blob> | undefined> {
  try {
    const response = await getRequestFileBlobGateway<Blob>(
      `${attachment.realmId}/${attachment.storageName}`
    )
    return response
  } catch (error: any) {
    Sentry.captureException(error)
    return undefined
  }
}
